import initModals from './components/modal';
import initReadMore from './modules/read-more-block';
import initHeaderNavigation from './template-parts/header-navigation';
import initAppearAnim from './utils/appear-anim';
import initOutils from './template-parts/outils-tabs';
import initMissions from './template-parts/mission';
import initEquipe from './template-parts/equipe';
import initInputCustom from './components/input-custom';
import initContactHeader from './template-parts/contact-header';
import initTabs from './template-parts/tabs';
import initHeroBanner from './template-parts/hero-banner';
import initAccordeons from './template-parts/texte-intro-accordeons';


// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);


// Utils
initAppearAnim();

// Template parts
initHeaderNavigation();
initHeroBanner();
initOutils();
initTabs();
initMissions();
initEquipe();
initContactHeader();
initAccordeons();

// Modules
initReadMore();

// Components (En dernier sinon les bouton modals dans un swiper ne s'initialise pas)
initInputCustom();
initModals();
